import { useState, useCallback, RefObject, useEffect } from 'react';

interface ChartDataItem {
    timestamp: number;
    [key: string]: any;
}

interface UseChartZoomProps {
    chartData: ChartDataItem[];
    initialStartIndex?: number;
    initialEndIndex?: number;
    chartContainerRef: RefObject<HTMLDivElement>;
}

export function useChartZoom({
    chartData,
    initialStartIndex = 0,
    initialEndIndex = chartData.length > 0 ? chartData.length - 1 : 0,
    chartContainerRef,
}: UseChartZoomProps) {
    const [zoomStartIndex, setZoomStartIndex] = useState<number>(initialStartIndex);
    const [zoomEndIndex, setZoomEndIndex] = useState<number>(initialEndIndex);
    const [isUserZoom, setIsUserZoom] = useState<boolean>(false);

    const handleZoomRangeChange = useCallback((startIndex: number, endIndex: number, userInitiated: boolean = true) => {
        const newStart = Math.max(0, Math.min(startIndex, chartData.length - 1));
        const newEnd = Math.min(chartData.length - 1, Math.max(endIndex, 0));

        if (newStart <= newEnd) {
            setZoomStartIndex(newStart);
            setZoomEndIndex(newEnd);
            setIsUserZoom(userInitiated);
        } else if (chartData.length > 0) {
            // console.warn("Attempted to set invalid zoom range in hook:", startIndex, endIndex);
        }
    }, [chartData.length]);

    const handleZoomReset = useCallback(() => {
        if (chartData.length > 0) {
            setZoomStartIndex(0);
            setZoomEndIndex(chartData.length - 1);
            setIsUserZoom(true); // Reset is considered user action
        }
    }, [chartData.length]);



    return {
        zoomStartIndex,
        zoomEndIndex,
        handleZoomReset,
        setZoomStartIndex,
        setZoomEndIndex,
        handleZoomRangeChange,
        isUserZoom
    };
}